import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import withStyles from 'isomorphic-style-loader/withStyles';
import s from './CancelBookingModal.css';

import CancelBookingForm from './CancelBookingForm';

import messages from '../../../locale/messages';

import { closeCancelManualBookingModal } from '../../../actions/siteadmin/modalActions';

class CancelBookingModal extends Component {
  render() {
    const { closeCancelManualBookingModal, cancelManualBookingModal, booking } = this.props;
    return (
      <div>
        <Modal show={cancelManualBookingModal} onHide={closeCancelManualBookingModal} className={'wooberlyModal'}>
          <Modal.Header closeButton>
            <Modal.Title><h2> <FormattedMessage {...messages.cancelBooking} /></h2></Modal.Title>
          </Modal.Header>
          <Modal.Body className={s.logInModalBody}>
            <div className={s.root}>
              <div className={s.container}>
                <CancelBookingForm booking={booking} />
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapState = (state) => ({
  cancelManualBookingModal: state.adminModalStatus.cancelManualBookingModal
});

const mapDispatch = {
  closeCancelManualBookingModal
};

export default withStyles(s)(connect(mapState, mapDispatch)(CancelBookingModal));